import { PLAYBOOK_IDS, TOUR_IDS } from "./tourIds";

const pingflo = "pingflo";
const pingwi = "pingwi";

function step(partial) {
  return {
    requireClick: true,
    skipIfMissing: false,
    ...partial,
  };
}

export const FIRST_JOB_BY_ROLE = {
  player: PLAYBOOK_IDS.playerCompanion,
  coach: PLAYBOOK_IDS.coachAddSession,
  admin: PLAYBOOK_IDS.adminInvite,
  parent: PLAYBOOK_IDS.parentRsvp,
};

function championshipStep(id, { titleKey, bodyKey, homeRole, agentId } = {}) {
  return step({
    id,
    tourId: TOUR_IDS.competitionCalendar,
    fallbackTourId: TOUR_IDS.playerCompetition,
    agentId: agentId || pingflo,
    titleKey: titleKey || "tour_comp_title",
    bodyKey: bodyKey || "tour_comp_body",
    route: "/competition",
    homeRole,
    navTourId: TOUR_IDS.navCompetition,
    requireClick: false,
    scroll: "topThenCenter",
  });
}

function presenceWalkSteps({ job = false } = {}) {
  const prefix = job ? "job-" : "";
  return [
    step({
      id: `${prefix}admin-presence-chart`,
      tourId: TOUR_IDS.adminPresenceChart,
      fallbackTourId: TOUR_IDS.adminPresenceCard,
      agentId: pingflo,
      titleKey: "tour_admin_presence_title",
      bodyKey: "tour_admin_presence_body",
      route: "/Dashboard",
      homeRole: "admin",
      closeSidebar: true,
      requireClick: false,
      keepFullHighlight: true,
      scroll: "topThenCenter",
      autoAdvanceAfterSpeech: true,
    }),
    step({
      id: `${prefix}admin-presence-open`,
      tourId: TOUR_IDS.adminPresenceOpen,
      fallbackTourId: TOUR_IDS.adminPresenceCard,
      agentId: pingflo,
      titleKey: "tour_admin_presence_open_title",
      bodyKey: "tour_admin_presence_open_body",
      route: "/Dashboard",
      homeRole: "admin",
      closeSidebar: true,
      requireClick: false,
      autoAdvanceMs: 1400,
      silent: true,
    }),
    step({
      id: `${prefix}admin-presence`,
      tourId: TOUR_IDS.adminPresenceBoard,
      agentId: pingflo,
      titleKey: "tour_admin_presence_board_title",
      bodyKey: "tour_admin_presence_board_body",
      route: "/Dashboard",
      homeRole: "admin",
      closeSidebar: true,
      arrive: { type: "openPanel", panel: "presenceReport" },
      requireClick: false,
    }),
  ];
}

function smartObjectivesStep(id, { titleKey, bodyKey, homeRole } = {}) {
  return step({
    id,
    tourId: TOUR_IDS.profileSmartObjectives,
    fallbackTourId: TOUR_IDS.profileSmartTab,
    agentId: pingflo,
    titleKey: titleKey || "tour_smart_title",
    bodyKey: bodyKey || "tour_smart_body",
    route: "/profile",
    homeRole,
    arrive: { type: "openPanel", panel: "profileSmart" },
    navTourId: TOUR_IDS.navProfile,
    readyTourId: TOUR_IDS.navProfile,
    requireClick: false,
  });
}

function inviteMethodsStep(id, { titleKey, bodyKey, homeRole } = {}) {
  return step({
    id,
    tourId: TOUR_IDS.adminInviteMethods,
    extraTourIds: [
      TOUR_IDS.adminInviteMethodLink,
      TOUR_IDS.adminInviteMethodEmail,
      TOUR_IDS.adminInviteMethodQr,
    ],
    fallbackTourId: TOUR_IDS.adminInvitePage,
    agentId: pingflo,
    titleKey: titleKey || "tour_admin_invite_title",
    bodyKey: bodyKey || "tour_admin_invite_body",
    route: "/InviteUser",
    homeRole: homeRole || "admin",
    navTourId: TOUR_IDS.adminNavInvite,
    requireClick: false,
  });
}

export function buildPlaybooks() {
  return {
    [PLAYBOOK_IDS.welcomePlayer]: {
      id: PLAYBOOK_IDS.welcomePlayer,
      role: "player",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "player-meet",
          tourId: TOUR_IDS.navHome,
          agentId: pingflo,
          titleKey: "tour_player_meet_title",
          bodyKey: "tour_player_meet_body",
          route: "/home",
          homeRole: "player",
          navTourId: TOUR_IDS.navHome,
          requireClick: false,
          doForMe: null,
        }),
        smartObjectivesStep("player-smart", {
          titleKey: "tour_player_smart_title",
          bodyKey: "tour_player_smart_body",
          homeRole: "player",
        }),
        step({
          id: "player-session",
          tourId: TOUR_IDS.playerNewSession,
          agentId: pingflo,
          titleKey: "tour_player_session_title",
          bodyKey: "tour_player_session_body",
          route: "/home",
          homeRole: "player",
          doForMe: { type: "openPanel", panel: "playerNewSession" },
          scroll: "topThenCenter",
        }),
        step({
          id: "player-calendar",
          tourId: TOUR_IDS.playerCalendar,
          agentId: pingflo,
          titleKey: "tour_player_calendar_title",
          bodyKey: "tour_player_calendar_body",
          route: "/home",
          requireClick: false,
        }),
        championshipStep("player-comp", {
          titleKey: "tour_player_comp_title",
          bodyKey: "tour_player_comp_body",
        }),
        step({
          id: "player-live-join",
          tourId: TOUR_IDS.navLive,
          agentId: pingflo,
          titleKey: "tour_live_join_title",
          bodyKey: "tour_live_join_body",
          route: "/home",
          homeRole: "player",
          navTourId: TOUR_IDS.navLive,
          requireClick: false,
        }),
        step({
          id: "player-live-table",
          tourId: TOUR_IDS.livePlayerTable,
          agentId: pingflo,
          titleKey: "tour_live_table_title",
          bodyKey: "tour_live_table_body",
          route: "/live-training",
          homeRole: "player",
          fallbackTourId: TOUR_IDS.livePlayerExercise,
          requireClick: false,
        }),
        step({
          id: "player-live-drill",
          tourId: TOUR_IDS.livePlayerExercise,
          agentId: pingflo,
          titleKey: "tour_live_drill_title",
          bodyKey: "tour_live_drill_body",
          route: "/live-training",
          homeRole: "player",
          fallbackTourId: TOUR_IDS.livePlayerHr,
          requireClick: false,
        }),
        step({
          id: "player-fab",
          tourId: TOUR_IDS.pingfloFab,
          agentId: pingflo,
          titleKey: "tour_companion_fab_title",
          bodyKey: "tour_player_fab_body",
          route: "/home",
          homeRole: "player",
          doForMe: { type: "openCompanion" },
        }),
        step({
          id: "player-tech",
          tourId: TOUR_IDS.pingfloFab,
          agentId: pingflo,
          titleKey: "tour_player_tech_title",
          bodyKey: "tour_player_tech_body",
          route: "/home",
          homeRole: "player",
          requireClick: false,
          choice: "technicalProfiling",
          skipIf: "technicalProfilingDone",
        }),
      ],
    },
    [PLAYBOOK_IDS.welcomeCoach]: {
      id: PLAYBOOK_IDS.welcomeCoach,
      role: "coach",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "coach-meet",
          tourId: TOUR_IDS.coachGroups,
          agentId: pingflo,
          titleKey: "tour_coach_meet_title",
          bodyKey: "tour_coach_meet_body",
          route: "/home",
          homeRole: "coach",
          requireClick: false,
        }),
        smartObjectivesStep("coach-smart", {
          titleKey: "tour_coach_smart_title",
          bodyKey: "tour_coach_smart_body",
          homeRole: "coach",
        }),
        step({
          id: "coach-dash",
          tourId: TOUR_IDS.navDashboard,
          agentId: pingflo,
          titleKey: "tour_coach_dash_title",
          bodyKey: "tour_coach_dash_body",
          route: "/home",
          homeRole: "coach",
          navTourId: TOUR_IDS.navDashboard,
          closeSidebar: true,
          requireClick: false,
        }),
        step({
          id: "coach-add",
          tourId: TOUR_IDS.coachAddSession,
          agentId: pingflo,
          titleKey: "tour_coach_add_title",
          bodyKey: "tour_coach_add_body",
          route: "/home",
          doForMe: { type: "openPanel", panel: "addSession" },
        }),
        step({
          id: "coach-planning",
          tourId: TOUR_IDS.coachPlanningBoard,
          agentId: pingflo,
          titleKey: "tour_coach_planning_title",
          bodyKey: "tour_coach_planning_body",
          route: "/planning",
          navTourId: TOUR_IDS.navPlanning,
          requireClick: false,
        }),
        step({
          id: "coach-split",
          tourId: TOUR_IDS.coachSplitGroup,
          agentId: pingflo,
          titleKey: "tour_coach_split_title",
          bodyKey: "tour_coach_split_body",
          route: "/planning",
          navTourId: TOUR_IDS.navPlanning,
          fallbackTourId: TOUR_IDS.coachPlanningBoard,
          requireClick: false,
        }),
        step({
          id: "coach-add-ex",
          tourId: TOUR_IDS.coachAddExercise,
          agentId: pingflo,
          titleKey: "tour_coach_add_ex_title",
          bodyKey: "tour_coach_add_ex_body",
          route: "/planning",
          navTourId: TOUR_IDS.navPlanning,
          fallbackTourId: TOUR_IDS.coachPlanningBoard,
          requireClick: false,
        }),
        step({
          id: "coach-training",
          tourId: TOUR_IDS.coachTrainingFloor,
          agentId: pingflo,
          titleKey: "tour_coach_training_title",
          bodyKey: "tour_coach_training_body",
          route: "/training",
          navTourId: TOUR_IDS.navTraining,
          requireClick: false,
        }),
        step({
          id: "coach-live-open",
          tourId: TOUR_IDS.liveTrainingOpen,
          agentId: pingflo,
          titleKey: "tour_live_open_title",
          bodyKey: "tour_live_open_body",
          route: "/live-training",
          homeRole: "coach",
          fallbackTourId: TOUR_IDS.liveCoachFloor,
          requireClick: false,
        }),
        step({
          id: "coach-live-tables",
          tourId: TOUR_IDS.liveCoachTables,
          agentId: pingflo,
          titleKey: "tour_live_tables_title",
          bodyKey: "tour_live_tables_body",
          route: "/live-training",
          homeRole: "coach",
          fallbackTourId: TOUR_IDS.liveCoachFloor,
          requireClick: false,
        }),
        step({
          id: "coach-live-start",
          tourId: TOUR_IDS.liveCoachStart,
          agentId: pingflo,
          titleKey: "tour_live_start_title",
          bodyKey: "tour_live_start_body",
          route: "/live-training",
          homeRole: "coach",
          fallbackTourId: TOUR_IDS.liveCoachFloor,
          requireClick: false,
        }),
        championshipStep("coach-comp", { homeRole: "coach" }),
        step({
          id: "coach-fab",
          tourId: TOUR_IDS.pingfloFab,
          agentId: pingflo,
          titleKey: "tour_companion_fab_title",
          bodyKey: "tour_coach_fab_body",
          doForMe: { type: "openCompanion" },
        }),
      ],
    },
    [PLAYBOOK_IDS.welcomeAdmin]: {
      id: PLAYBOOK_IDS.welcomeAdmin,
      role: "admin",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "admin-meet",
          tourId: TOUR_IDS.adminDashboard,
          agentId: pingflo,
          titleKey: "tour_admin_meet_title",
          bodyKey: "tour_admin_meet_body",
          route: "/Dashboard",
          homeRole: "admin",
          navTourId: TOUR_IDS.navDashboard,
          closeSidebar: true,
          requireClick: false,
        }),
        step({
          id: "admin-smart",
          tourId: TOUR_IDS.adminProfileSmart,
          fallbackTourId: TOUR_IDS.navProfile,
          agentId: pingflo,
          titleKey: "tour_admin_smart_title",
          bodyKey: "tour_admin_smart_body",
          route: "/profile",
          homeRole: "admin",
          navTourId: TOUR_IDS.navProfile,
          readyTourId: TOUR_IDS.navProfile,
          requireClick: false,
          scroll: "topThenCenter",
        }),
        ...presenceWalkSteps(),
        step({
          id: "admin-groups",
          tourId: TOUR_IDS.adminGroupsPage,
          agentId: pingflo,
          titleKey: "tour_admin_groups_title",
          bodyKey: "tour_admin_groups_body",
          route: "/GroupList",
          navTourId: TOUR_IDS.adminNavGroups,
          requireClick: false,
        }),
        championshipStep("admin-comp", { homeRole: "admin" }),
        inviteMethodsStep("admin-invite"),
        step({
          id: "admin-fab",
          tourId: TOUR_IDS.pingfloFab,
          agentId: pingflo,
          titleKey: "tour_companion_fab_title",
          bodyKey: "tour_admin_fab_body",
          doForMe: { type: "openCompanion" },
        }),
      ],
    },
    [PLAYBOOK_IDS.welcomeParent]: {
      id: PLAYBOOK_IDS.welcomeParent,
      role: "parent",
      hostAgentId: pingwi,
      steps: [
        step({
          id: "parent-meet",
          tourId: TOUR_IDS.parentHub,
          agentId: pingwi,
          titleKey: "tour_parent_meet_title",
          bodyKey: "tour_parent_meet_body",
          route: "/parent/progress",
          homeRole: "parent",
          navTourId: TOUR_IDS.navParentHub,
          requireClick: false,
          scroll: "topThenCenter",
        }),
        step({
          id: "parent-children",
          tourId: TOUR_IDS.parentChildren,
          agentId: pingwi,
          titleKey: "tour_parent_children_title",
          bodyKey: "tour_parent_children_body",
          route: "/parent/progress",
          homeRole: "parent",
          navTourId: TOUR_IDS.navParentHub,
          requireClick: false,
          scroll: "topThenCenter",
        }),
        step({
          id: "parent-smart",
          tourId: TOUR_IDS.parentSmart,
          fallbackTourId: TOUR_IDS.parentHub,
          agentId: pingwi,
          titleKey: "tour_parent_smart_title",
          bodyKey: "tour_parent_smart_body",
          route: "/parent/progress",
          homeRole: "parent",
          navTourId: TOUR_IDS.navParentHub,
          requireClick: false,
          scroll: "topThenCenter",
        }),
        step({
          id: "parent-rsvp",
          tourId: TOUR_IDS.parentRsvp,
          agentId: pingwi,
          titleKey: "tour_parent_rsvp_title",
          bodyKey: "tour_parent_rsvp_body",
          route: "/parent/progress",
          homeRole: "parent",
          navTourId: TOUR_IDS.navParentHub,
          requireClick: false,
          keepFullHighlight: true,
          scroll: "topThenCenter",
        }),
        step({
          id: "parent-medical",
          tourId: TOUR_IDS.parentMedical,
          fallbackTourId: TOUR_IDS.parentHub,
          agentId: pingwi,
          titleKey: "tour_parent_medical_title",
          bodyKey: "tour_parent_medical_body",
          route: "/parent/progress",
          homeRole: "parent",
          navTourId: TOUR_IDS.navParentHub,
          requireClick: false,
          scroll: "topThenCenter",
        }),
        championshipStep("parent-comp", {
          titleKey: "tour_parent_comp_title",
          bodyKey: "tour_parent_comp_body",
          homeRole: "parent",
          agentId: pingwi,
        }),
        step({
          id: "parent-fab",
          tourId: TOUR_IDS.pingfloFab,
          agentId: pingwi,
          titleKey: "tour_companion_fab_title",
          bodyKey: "tour_parent_fab_body",
          route: "/parent/progress",
          homeRole: "parent",
          doForMe: { type: "openCompanion" },
        }),
      ],
    },
    [PLAYBOOK_IDS.playerNewSession]: {
      id: PLAYBOOK_IDS.playerNewSession,
      role: "player",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-player-session",
          tourId: TOUR_IDS.playerNewSession,
          agentId: pingflo,
          titleKey: "tour_player_session_title",
          bodyKey: "tour_player_session_body",
          route: "/home",
          homeRole: "player",
          arrive: { type: "openPanel", panel: "playerNewSession" },
          scroll: "topThenCenter",
        }),
      ],
    },
    [PLAYBOOK_IDS.playerCompanion]: {
      id: PLAYBOOK_IDS.playerCompanion,
      role: "player",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-player-fab",
          tourId: TOUR_IDS.pingfloFab,
          agentId: pingflo,
          titleKey: "tour_companion_fab_title",
          bodyKey: "tour_player_fab_body",
          route: "/home",
          homeRole: "player",
          doForMe: { type: "openCompanion" },
        }),
      ],
    },
    [PLAYBOOK_IDS.playerCompetition]: {
      id: PLAYBOOK_IDS.playerCompetition,
      role: "player",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-player-comp",
          tourId: TOUR_IDS.competitionCalendar,
          fallbackTourId: TOUR_IDS.playerCompetition,
          agentId: pingflo,
          titleKey: "tour_player_comp_title",
          bodyKey: "tour_player_comp_body",
          route: "/competition",
          navTourId: TOUR_IDS.navCompetition,
          requireClick: false,
        }),
      ],
    },
    [PLAYBOOK_IDS.coachAddSession]: {
      id: PLAYBOOK_IDS.coachAddSession,
      role: "coach",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-coach-add",
          tourId: TOUR_IDS.coachAddSession,
          agentId: pingflo,
          titleKey: "tour_coach_add_title",
          bodyKey: "tour_first_job_coach_body",
          route: "/home",
          homeRole: "coach",
          arrive: { type: "openPanel", panel: "addSession" },
        }),
      ],
    },
    [PLAYBOOK_IDS.coachPlanning]: {
      id: PLAYBOOK_IDS.coachPlanning,
      role: "coach",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-coach-planning",
          tourId: TOUR_IDS.coachPlanningBoard,
          agentId: pingflo,
          titleKey: "tour_coach_planning_title",
          bodyKey: "tour_coach_planning_body",
          route: "/planning",
          homeRole: "coach",
          navTourId: TOUR_IDS.navPlanning,
          requireClick: false,
        }),
        step({
          id: "job-coach-split",
          tourId: TOUR_IDS.coachSplitGroup,
          agentId: pingflo,
          titleKey: "tour_coach_split_title",
          bodyKey: "tour_coach_split_body",
          route: "/planning",
          homeRole: "coach",
          navTourId: TOUR_IDS.navPlanning,
          fallbackTourId: TOUR_IDS.coachPlanningBoard,
          requireClick: false,
        }),
        step({
          id: "job-coach-add-ex",
          tourId: TOUR_IDS.coachAddExercise,
          agentId: pingflo,
          titleKey: "tour_coach_add_ex_title",
          bodyKey: "tour_coach_add_ex_body",
          route: "/planning",
          homeRole: "coach",
          navTourId: TOUR_IDS.navPlanning,
          fallbackTourId: TOUR_IDS.coachPlanningBoard,
          requireClick: false,
        }),
      ],
    },
    [PLAYBOOK_IDS.adminInvite]: {
      id: PLAYBOOK_IDS.adminInvite,
      role: "admin",
      hostAgentId: pingflo,
      steps: [
        inviteMethodsStep("job-admin-invite", {
          bodyKey: "tour_first_job_admin_body",
        }),
      ],
    },
    [PLAYBOOK_IDS.adminGroups]: {
      id: PLAYBOOK_IDS.adminGroups,
      role: "admin",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-admin-groups",
          tourId: TOUR_IDS.adminGroupsPage,
          agentId: pingflo,
          titleKey: "tour_admin_groups_title",
          bodyKey: "tour_admin_groups_body",
          route: "/GroupList",
          homeRole: "admin",
          navTourId: TOUR_IDS.adminNavGroups,
          requireClick: false,
        }),
      ],
    },
    [PLAYBOOK_IDS.adminPresence]: {
      id: PLAYBOOK_IDS.adminPresence,
      role: "admin",
      hostAgentId: pingflo,
      steps: presenceWalkSteps({ job: true }),
    },
    [PLAYBOOK_IDS.parentRsvp]: {
      id: PLAYBOOK_IDS.parentRsvp,
      role: "parent",
      hostAgentId: pingwi,
      steps: [
        step({
          id: "job-parent-rsvp",
          tourId: TOUR_IDS.parentRsvp,
          agentId: pingwi,
          titleKey: "tour_parent_rsvp_title",
          bodyKey: "tour_first_job_parent_body",
          route: "/parent/progress",
          homeRole: "parent",
          requireClick: false,
        }),
      ],
    },
    [PLAYBOOK_IDS.playerLive]: {
      id: PLAYBOOK_IDS.playerLive,
      role: "player",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-player-live-join",
          tourId: TOUR_IDS.navLive,
          agentId: pingflo,
          titleKey: "tour_live_join_title",
          bodyKey: "tour_live_join_body",
          route: "/home",
          homeRole: "player",
          navTourId: TOUR_IDS.navLive,
          requireClick: false,
        }),
        step({
          id: "job-player-live-table",
          tourId: TOUR_IDS.livePlayerTable,
          agentId: pingflo,
          titleKey: "tour_live_table_title",
          bodyKey: "tour_live_table_body",
          route: "/live-training",
          homeRole: "player",
          fallbackTourId: TOUR_IDS.livePlayerExercise,
          requireClick: false,
        }),
        step({
          id: "job-player-live-drill",
          tourId: TOUR_IDS.livePlayerExercise,
          agentId: pingflo,
          titleKey: "tour_live_drill_title",
          bodyKey: "tour_live_drill_body",
          route: "/live-training",
          homeRole: "player",
          fallbackTourId: TOUR_IDS.livePlayerHr,
          requireClick: false,
        }),
      ],
    },
    [PLAYBOOK_IDS.coachLive]: {
      id: PLAYBOOK_IDS.coachLive,
      role: "coach",
      hostAgentId: pingflo,
      steps: [
        step({
          id: "job-coach-live-open",
          tourId: TOUR_IDS.liveTrainingOpen,
          agentId: pingflo,
          titleKey: "tour_live_open_title",
          bodyKey: "tour_live_open_body",
          route: "/live-training",
          homeRole: "coach",
          fallbackTourId: TOUR_IDS.liveCoachFloor,
          requireClick: false,
        }),
        step({
          id: "job-coach-live-tables",
          tourId: TOUR_IDS.liveCoachTables,
          agentId: pingflo,
          titleKey: "tour_live_tables_title",
          bodyKey: "tour_live_tables_body",
          route: "/live-training",
          homeRole: "coach",
          fallbackTourId: TOUR_IDS.liveCoachFloor,
          requireClick: false,
        }),
        step({
          id: "job-coach-live-start",
          tourId: TOUR_IDS.liveCoachStart,
          agentId: pingflo,
          titleKey: "tour_live_start_title",
          bodyKey: "tour_live_start_body",
          route: "/live-training",
          homeRole: "coach",
          fallbackTourId: TOUR_IDS.liveCoachFloor,
          requireClick: false,
        }),
      ],
    },
  };
}

const PLAYBOOKS = buildPlaybooks();

let overlayById = {};

export function setTourPlaybookOverlays(map) {
  overlayById = map && typeof map === "object" ? map : {};
}

export function mergePlaybook(base, overlay) {
  if (!base) return null;
  if (!overlay || typeof overlay !== "object") return base;
  const overlaySteps = Array.isArray(overlay.steps) ? overlay.steps.filter(Boolean) : null;
  return {
    ...base,
    hostAgentId: overlay.hostAgentId || base.hostAgentId,
    steps: overlaySteps?.length ? overlaySteps.map((s) => step({ ...s })) : base.steps,
  };
}

export function listPlaybookCatalog() {
  return Object.values(buildPlaybooks());
}

export function resolvePlaybook(playbookId, { role } = {}) {
  const catalog = buildPlaybooks();
  const base = playbookId && catalog[playbookId]
    ? catalog[playbookId]
    : role === "coach"
      ? catalog[PLAYBOOK_IDS.welcomeCoach]
      : role === "admin"
        ? catalog[PLAYBOOK_IDS.welcomeAdmin]
        : role === "parent"
          ? catalog[PLAYBOOK_IDS.welcomeParent]
          : role === "player"
            ? catalog[PLAYBOOK_IDS.welcomePlayer]
            : PLAYBOOKS[playbookId] || null;
  if (!base) return null;
  return mergePlaybook(base, overlayById[base.id]);
}

export function welcomePlaybookIdForRole(role) {
  if (role === "coach") return PLAYBOOK_IDS.welcomeCoach;
  if (role === "admin") return PLAYBOOK_IDS.welcomeAdmin;
  if (role === "parent") return PLAYBOOK_IDS.welcomeParent;
  return PLAYBOOK_IDS.welcomePlayer;
}
